/**
 * InsightOverlay - Insights flutuantes entre os cards
 * 
 * - Aparecem com fade + leve subida
 * - Máximo 1 insight por vez
 * - Desaparecem ao scroll
 * - Nunca bloqueiam interação
 */

import React, { useState, useEffect } from 'react';

export default function InsightOverlay({
  insight = '',
  visible = false,
}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible && insight) {
      // Small delay for entrance animation
      const timer = setTimeout(() => setShow(true), 100);
      return () => clearTimeout(timer);
    } else {
      setShow(false);
    }
  }, [visible, insight]);

  if (!insight) return null;

  return (
    <div
      className={`
        fixed left-1/2 -translate-x-1/2 z-40
        pointer-events-none
        transition-all duration-500 ease-out
        ${show 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-4'
        }
      `}
      style={{ top: '25%' }}
    >
      <div 
        className="px-5 py-3 rounded-full shadow-lg"
        style={{
          background: 'rgba(255, 251, 245, 0.95)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(180, 160, 130, 0.2)',
        }}
      >
        <p className="text-sm text-stone-600 flex items-center gap-2">
          <span className="text-amber-500">✨</span>
          {insight}
        </p>
      </div>
    </div>
  );
}
